// src/services/paymentService.js
import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL  || 'http://localhost:3000/api';

// Get auth token from localStorage
const getAuthHeader = () => {
  const token = localStorage.getItem('access_token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

// Create Payment Intent
export const createPaymentIntent = async (paymentData) => {
  try {
    const response = await axios.post(
      `${API_URL}/payments/create-payment-intent`,
      paymentData,
      getAuthHeader()
    );
    return response;
  } catch (error) {
    console.error('Error creating payment intent:', error);
    throw error;
  }
};

// Verify Payment
export const verifyPayment = async (verificationData) => {
  try {
    const response = await axios.post(
      `${API_URL}/payments/verify-payment`,
      verificationData,
      getAuthHeader()
    );
    return response;
  } catch (error) {
    console.error('Error verifying payment:', error);
    throw error;
  }
};

// Get Payment Status
export const getPaymentStatus = async (paymentIntentId) => {
  try {
    const response = await axios.get(
      `${API_URL}/payments/payment-status/${paymentIntentId}`,
      getAuthHeader()
    );
    return response;
  } catch (error) {
    console.error('Error getting payment status:', error);
    throw error;
  }
};
